import {parse, parseISO} from 'date-fns';
import {Maybe} from '../../../graphql/generated/types';

export function parseDate(_param: Maybe<string | number>, format?: string) {
  const param = _param || '';
  if (typeof param === 'number') {
    return new Date(param);
  }
  const currentDate = new Date();

  if (REGEX_ISO.test(param)) {
    const parsedDate = parseISO(param);
    return isNaN(parsedDate.getDate()) ? currentDate : parsedDate;
  }

  const dateString = REGEX_DATE.test(param) ? `${param} 00:00:00` : param;
  const parsedDate = parse(
    dateString,
    format ?? DEFAULT_DATETIME_FORMAT,
    currentDate
  );
  return isNaN(parsedDate.getDate()) ? currentDate : parsedDate;
}

const DEFAULT_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
const REGEX_DATE = /^\d{4}-\d{2}-\d{2}$/;
const REGEX_ISO = /^\d{4}-\d{2}-\d{2}T/;
